import {
  getCompanies,
  getCompany,
  removeCompany,
  getCountries,
  getCategories,
  getCountryDatasets,
  getStaff,
  createCompany,
  createPaymentInfo,
  createSubscription,
  addCompanyUser,
  // requests for edit
  editCompanyInfo,
  editCompanyPaymentIndo,
  editCompanySubscription,
  removeUser,
  getAudienceActivity,
  editCompanyInfoOwner
} from "./companies";

export default class CRMAPI {
  static getCompanies = getCompanies;

  static getCompany = getCompany;

  static createCompany = createCompany;

  static removeCompany = removeCompany;

  static getCountries = getCountries;

  static getStaff = getStaff;

  static createPaymentInfo = createPaymentInfo;

  static getCategories = getCategories;

  static getCoutryDatasets = getCountryDatasets;

  static createSubscription = createSubscription;

  static addCompanyUser = addCompanyUser;

  static editCompanyInfo = editCompanyInfo;

  static editCompanyPaymentIndo = editCompanyPaymentIndo;

  static editCompanySubscription = editCompanySubscription;

  static removeUser = removeUser;

  static getAudienceActivity = getAudienceActivity;

  static editCompanyInfoOwner = editCompanyInfoOwner;
}
